
import Layout from "../../../components/layout";
import LogoSlider from "../../../components/logo-slider";
import PageHeading from "../../../components/page-header";

import fs from 'fs';
import path from 'path';

export async function getStaticProps() {
  const dir = path.join(process.cwd(), 'public/images/companies');
  const files = fs.readdirSync(dir);
  const logos = files.map((file) => `/images/companies/${file}`);

  return {
    props: { logos },
  };
}



export default function Lighting({ logos }) {


  return (
      <Layout>
        <PageHeading heading_text='Lighting' image_url={'/images/heroslider/lighting.webp'}/>

        <div className="section white-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Precision Lighting That Sets the Mood.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">Lighting by Proslv — Designed to Perform</h5>
                        <p className="section-description">At Proslv, we believe lighting is more than illumination — it's an integral part of how a space feels and functions. From high-performance control rooms to immersive training theaters, our intelligent lighting solutions are tailored to support every environment’s purpose. Seamlessly integrated and aesthetically refined, our systems bring precision, mood, and smart control into perfect balance.
                           <br/> <br/>
                         Proslv lighting — built to elevate every moment.
                        </p>
                </div>
            </div>
          </div>
        </div>

        <div className="section black-bg client-section">


    <LogoSlider logos={logos}/>

    <div className="section-separator"></div>

    <div class="projects-section container mt-5">
    <h2 class="highlight-title mb-5">Our Projects</h2>
    <div class="projects-grid">
      <div class="project-card">
        <img src="/images/lighting/prulife_lighting.jpg" alt="Project 1" />
        <h3>PruLife</h3>
        <p>PruLife Headquarters Lighting Setup</p>
      </div>
      {/* <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1025" alt="Project 2" />
        <h3>Project Two</h3>
        <p>Custom AV integration for corporate setups.</p>
      </div>
      <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1033" alt="Project 3" />
        <h3>Project Three</h3>
        <p>Immersive sound systems for theaters.</p>
      </div>
      <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1033" alt="Project 3" />
        <h3>Project Three</h3>
        <p>Immersive sound systems for theaters.</p>
      </div> */}
      
    </div>
  </div>
  </div>

      </Layout>
  );
}
